
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 57 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.92 7.419l-.472-.471-5.84-5.834a.668.668 0 00-.943 0 .666.666 0 000 .943l4.699 4.695H.748c-.369 0-.667 0-.667.667s.298.667.667.667h53.616l-4.7 4.695a.665.665 0 000 .943.67.67 0 00.945 0l6.31-6.305z","fill-rule":"evenodd"}})])
          )
        }
      }
    